import React from 'react';
import { ArrowRight, Sparkles } from 'lucide-react';
import { Link } from 'react-router-dom';

const Hero = () => {
  return (
    <section className="relative min-h-screen flex items-center justify-center pt-20 pb-16 overflow-hidden">
      {/* Background Gradient */}
      <div className="absolute inset-0 bg-gradient-to-br from-beige-200 via-beige-100 to-brown-100"></div>

      {/* Floating decorative elements */}
      <div className="absolute top-20 left-10 w-20 h-20 bg-brown-400/20 rounded-full blur-xl"></div>
      <div className="absolute bottom-20 right-10 w-32 h-32 bg-beige-300/30 rounded-full blur-2xl"></div>
      <div className="absolute top-1/2 left-1/4 w-16 h-16 bg-brown-300/20 rounded-full blur-lg"></div>

      <div className="container mx-auto px-4 relative z-10">
        <div className="max-w-4xl mx-auto text-center">
          <div className="inline-flex items-center space-x-2 mb-6 px-4 py-2 glass rounded-full">
            <Sparkles className="w-5 h-5 text-brown-700" />
            <span className="text-brown-800 font-medium">Your trusted UK casino guide since 2025</span>
          </div>

          <h1 className="text-5xl md:text-7xl font-bold text-brown-900 mb-6 leading-tight">
            Find Your Perfect
            <span className="block text-transparent bg-clip-text bg-gradient-to-r from-brown-700 to-brown-500">
              Casino Experience
            </span>
          </h1>

          <p className="text-xl md:text-2xl text-brown-700 mb-10 max-w-2xl mx-auto leading-relaxed">
            Compare top-rated UK casinos, grab exclusive bonuses, and unlock winning strategies all in one place. 
            Your next big win starts here.
          </p>

          {/* Navigation Links */}
          <div className="flex flex-wrap justify-center gap-3 mb-10">
            {[
              { id: 'offers', label: 'Offers' },
              { id: 'about', label: 'About Us' },
              { id: 'guides', label: 'Guides' },
              { id: 'faq', label: 'FAQ' },
              { id: 'news', label: 'News' },
              { id: 'contact', label: 'Contact' }
            ].map((link) => (
              <a
                key={link.id}
                href={`#${link.id}`}
                onClick={(e) => {
                  e.preventDefault();
                  const element = document.getElementById(link.id);
                  if (element) {
                    element.scrollIntoView({ behavior: 'smooth', block: 'start' });
                  }
                }}
                className="px-5 py-2 glass rounded-full text-brown-800 font-medium hover:bg-white/40 transition-all duration-300 hover:scale-105"
              >
                {link.label}
              </a>
            ))}
          </div>

          

          <div className="mt-16 grid grid-cols-1 md:grid-cols-3 gap-6 max-w-3xl mx-auto">
            <div className="glass-strong p-6 rounded-2xl">
              <div className="text-3xl font-bold text-brown-700 mb-2">50+</div>
              <div className="text-brown-600">Reviewed Casinos</div>
            </div>
            <div className="glass-strong p-6 rounded-2xl">
              <div className="text-3xl font-bold text-brown-700 mb-2">£500+</div>
              <div className="text-brown-600">Exclusive Bonuses</div>
            </div>
            <div className="glass-strong p-6 rounded-2xl">
              <div className="text-3xl font-bold text-brown-700 mb-2">24/7</div>
              <div className="text-brown-600">Expert Support</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;

